import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogDismiss,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  buttonVariants,
} from '@barfacil/barfacil-ui'
import { Trash } from 'lucide-react'
import { useState } from 'react'

import { useDeleteProduct } from '@/app/panel/management/price-list/_hooks/use-delete-product'
import { cn } from '@/lib/utils'

type DeleteProductDialogProps = {
  priceListProductId: number
  name: string
}

export const DeleteProductDialog = ({
  name,
  priceListProductId,
}: DeleteProductDialogProps) => {
  const [open, setOpen] = useState(false)

  const { mutation } = useDeleteProduct()

  async function handleOnDelete() {
    await mutation.mutateAsync(
      { id: priceListProductId },
      { onSuccess: () => setOpen(false) },
    )
  }

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button className="size-6" variant="ghost" size="icon">
          <Trash size={20} />
        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>REMOVER PRODUTO</AlertDialogTitle>

          <AlertDialogDescription>
            TEM CERTEZA QUE DESEJA REMOVER O PRODUTO &quot;
            <strong>{name}</strong>
            &quot;?
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="sm:justify-self-end">
          <AlertDialogCancel
            className={cn(buttonVariants({ variant: 'tertiary' }), 'sm:w-32')}
          >
            Cancelar
          </AlertDialogCancel>
          <Button
            className={cn(buttonVariants({ variant: 'danger' }), 'sm:w-32')}
            onClick={handleOnDelete}
            isLoading={mutation.isPending}
            disabled={mutation.isPending}
          >
            Confirmar
          </Button>
        </AlertDialogFooter>

        <AlertDialogDismiss className="absolute right-6 top-6" />
      </AlertDialogContent>
    </AlertDialog>
  )
}
